<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title" class="ma-2">
			<template v-slot:app-bar-btn>
				<v-btn
					v-if="selectedTeam"
					color="primary"
					@click="showUnassignedOrders = !showUnassignedOrders"
					>未割振製造オーダートレー</v-btn
				>
			</template>

			<v-main>
				<v-row no-gutters justify="end">
					<v-col cols="12" lg="3" sm="6" md="4">
						<v-select
							label="チームを選択"
							class="mt-2"
							v-model="selectedTeam"
							:items="teams"
							item-text="name"
							item-value="id"
							@change="setTeam"
							dense
							outlined
							:hint="!selectedTeam ? 'チームを選択してください' : ''"
							:persistent-hint="!selectedTeam"
						/>
					</v-col>
				</v-row>

				<v-container v-if="showTrashCan" fluid>
					<v-row>
						<v-col cols="12">
							<v-card @dragover.prevent @drop="onDropToTrash">
								<v-card-text>ここにドロップして担当者からオーダーを削除</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-container fluid>
					<v-row>
						<v-col v-for="(user, index) in users" :key="index" cols="12" md="6" lg="4">
							<v-card @dragover.prevent @drop="onDropToUser(user)">
								<v-card-title>{{ user.full_name }}</v-card-title>
								<v-card-text>
									<v-list dense>
										<v-list-item
											v-for="(order, i) in user.order_individual_infos"
											:key="index + '-' + i"
											class="pa-1"
										>
											<v-card
												draggable
												@dragstart="onDragStartFromUser(order, index, i)"
												class="grab"
											>
												<v-card-text class="pa-1"
													>製造番号：{{ order.ordered_product.product_number }}-{{
														order.sub_number
													}}</v-card-text
												>
												<v-card-title class="text-subtitle-2 pa-1"
													>{{ order.ordered_product.product.name }}
													{{ order.ordered_product.sub_name }}</v-card-title
												>
												<v-card-text class="pa-1"
													>数量：{{ order.quantity }}{{ " " }}出荷日：{{
														order.delivery_info.shipping_date
															? common.formatDateWithDay(order.delivery_info.shipping_date)
															: "未設定"
													}}</v-card-text
												>
											</v-card>
										</v-list-item>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-container v-if="showUnassignedOrders" fluid>
					<v-row style="background-color: #f2f2f2">
						<v-col v-for="(order, index) in unassignedOrders" :key="index" cols="12" md="4" lg="3">
							<v-card draggable @dragstart="onDragStart(order, index)" class="grab">
								<v-card-text class="pa-1"
									>製造番号：{{ order.ordered_product.product_number }}-{{
										order.sub_number
									}}</v-card-text
								>
								<v-card-title class="text-subtitle-2 pa-1"
									>{{ order.ordered_product.product.name }}
									{{ order.ordered_product.sub_name }}</v-card-title
								>
								<v-card-text class="pa-1"
									>数量：{{ order.quantity }}{{ " " }}出荷日：{{
										order.delivery_info.shipping_date
											? common.formatDateWithDay(order.delivery_info.shipping_date)
											: "未設定"
									}}</v-card-text
								>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-main>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			common: common,
			title: "メンバーへ割振",
			selectedTeam: null,
			teams: [],
			users: [],
			unassignedOrders: [],
			showUnassignedOrders: true,
			showTrashCan: false,
			draggingOrder: null,
			userToUser: false,
			fromUserIndex: null,
			formUserOrderIndex: null,
			trayToUser: false,
			fromTrayIndex: null,
		}
	},
	mounted() {
		this.getTeams()
	},
	methods: {
		getTeams() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_allocations/to_team_members`
			axios
				.get(url, { headers })
				.then((response) => {
					this.teams = response.data.teams
				})
				.catch((error) => {
					errorHandling.errorResponse(error)
				})
		},
		setTeam(e) {
			if (!e) return
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_allocations/to_team_members/${e}`
			axios
				.get(url, { headers })
				.then((response) => {
					this.users = response.data.users.map((user) => {
						user.order_individual_infos = []
						return user
					})
					this.setOrderIndividualInfos(response.data.order_individual_infos)
				})
				.catch((error) => {
					errorHandling.errorResponse(error)
				})
		},
		setOrderIndividualInfos(order_individual_infos) {
			order_individual_infos.forEach((orderIndividualInfo) => {
				if (orderIndividualInfo.order_individual_info_users.length) {
					orderIndividualInfo.order_individual_info_users.find((orderIndividualInfoUser) => {
						const user = this.users.find((user) => user.id === orderIndividualInfoUser.user_id)
						if (user) {
							user.order_individual_infos.push(orderIndividualInfo)
						} else {
							this.unassignedOrders.push(orderIndividualInfo)
						}
					})
				} else {
					this.unassignedOrders.push(orderIndividualInfo)
				}
			})
		},
		onDragStart(order) {
			this.draggingOrder = order
			this.showTrashCan = true
			this.trayToUser = true
		},
		onDragStartFromUser(order, userIndex, orderIndex) {
			this.draggingOrder = order
			this.showTrashCan = true
			this.userToUser = true
			this.fromUserIndex = userIndex
			this.formUserOrderIndex = orderIndex
		},
		onDropToUser(user) {
			console.log(user)
			const existOrderIndividualInfo = user.order_individual_infos.find(
				(order) => order.id === this.draggingOrder.id
			)
			if (existOrderIndividualInfo) return
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/order_allocations/to_team_members",
					{
						order_individual_info_id: this.draggingOrder.id,
						user_id: user.id,
					},
					{ headers }
				)
				.then((response) => {
					// 成功時の処理
					user.order_individual_infos.push(this.draggingOrder)
					this.draggingOrder = null
					this.$store.dispatch("setFlash", {
						text: response.data.message,
						type: "notice",
					})
					// ユーザー間のドラッグアンドドロップの場合
					if (this.userToUser == true) {
						this.users[this.fromUserIndex].order_individual_infos.splice(
							[this.formUserOrderIndex],
							1
						)
						this.formUserOrderIndex = null
						this.userToUser = false
						this.fromUserIndex = null
					}
					// トレイからユーザーへのドラッグアンドドロップの場合
					if (this.trayToUser) {
						this.unassignedOrders.splice(this.fromTrayIndex, 1)
						this.trayToUser = false
						this.fromTrayIndex = null
					}
				})
				.catch((error) => {
					errorHandling.errorResponse(error)
					this.draggingOrder = null
					this.fromUserIndex = null
					this.userToUser = false
					this.formUserOrderIndex = null
					this.trayToUser = false
					this.fromTrayIndex = null
				})
		},
		onDropToTrash() {
			if (this.userToUser) {
				const headers = authenticate.setHeader()
				const url = `/erp/v1/order_allocations/to_team_members/${this.draggingOrder.id}`
				axios
					.delete(url, {
						params: {
							user_id: this.users[this.fromUserIndex].id,
						},
						headers,
					})
					.then((response) => {
						this.$store.dispatch("setFlash", {
							text: response.data.message,
							type: "notice",
						})
						this.users[this.fromUserIndex].order_individual_infos.splice(
							[this.formUserOrderIndex],
							1
						)
						this.draggingOrder = null
						this.userToUser = false
						this.fromUserIndex = null
						this.formUserOrderIndex = null
					})
					.catch((error) => {
						this.userToUser = false
						this.fromUserIndex = null
						this.formUserOrderIndex = null
						errorHandling.errorResponse(err)
					})
			}
		},
	},
}
</script>
<style lang="scss">
.grab {
	cursor: grab;
	&:active {
		cursor: grabbing;
	}
}
</style>
